import { InfoIcon } from 'assets/icons/InfoIcon'

export const STATUS_STYLE_BY_STATUS_VALUE = {
  0: '#3888ff',
  1: '#3888ff',
  11: '#fba909',
  12: '#3888ff',
  13: '#47d068',
  20: '#ffffff',
  30: '#fb0943',
  31: '#fb0943',
  32: '#ffffff',
} as const
export const STATUS_NAME_BY_STATUS_VALUE = {
  0: 'New', //  Waiting for tuning
  1: 'Ready', //  Configured.Can be started.Waiting for a payment
  11: 'On Moderation', //  Payed.On moderation
  12: 'Scheduled', //  At least one place approved.At least one playback is scheduled
  13: 'In Progress', //  At least one playback processed successfully
  20: 'Completed', //  All planned playbacks are processed successfully
  30: 'On Hold', //  Cancelled by moderators
  31: 'Cancelled', //  Cancelled by user
  32: 'Expired',
} as const

export const CAMPAIGN_STATUS_ICON_BY_VALUE_FILTER = {
  '': <InfoIcon style={{ width: '1.5rem' }} />,
  '0-Number-eq': <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#3888ff' }} />,
  '1-Number-eq': <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#3888ff' }} />,
  '11-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#fba909' }} />
  ),
  '12-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#3888ff' }} />
  ),
  '13-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#47d068' }} />
  ),
  '20-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#ffffff' }} />
  ),
  '30-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#fb0943' }} />
  ),
  '31-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#fb0943' }} />
  ),
  '32-Number-eq': (
    <div style={{ width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: '#ffffff' }} />
  ),
}

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: '0-Number-eq', label: 'New' },
  { value: '1-Number-eq', label: 'Ready' },
  { value: '11-Number-eq', label: 'On Moderation' },
  { value: '12-Number-eq', label: 'Scheduled' },
  { value: '13-Number-eq', label: 'In Progress' },
  { value: '20-Number-eq', label: 'Completed' },
  { value: '30-Number-eq', label: 'On Hold' },
  { value: '31-Number-eq', label: 'Cancelled' },
  { value: '32-Number-eq', label: 'Expired' },
]
